<template>
  <div class="step">
    <div class="step__section">
      <div class="step__header">
        <div class="step__header__title">
          {{ asideData.stepData.step1.name }}
        </div>
        <div
          class="step__header__icon"
          :style="{
            '--bg': asideData.stepData.step1.niche.background
          }"
        >
          <img :src="asideData.stepData.step1.niche.icon" />
        </div>
      </div>
    </div>
    <div class="step__section">
      <div class="step__card">
        <div class="step__card__title">
          {{
            asideData.stepData.step2.coachList.length > 1
              ? 'Достижения тренеров'
              : 'Достижения тренера'
          }}
        </div>
        <div
          v-for="(coach, coachIndex) in asideData.stepData.step2.coachList"
          :key="coachIndex"
          class="step__card__coach-section"
        >
          <div class="step__card__coach-title">
            {{ coach.name }}
          </div>
          <div class="step__card__list">
            <li v-for="(achievement, index) in coach.achievements" :key="'achievement-' + index">
              {{ achievement }}
            </li>
          </div>
          <div class="step__card__business"><span>Бизнес: </span> {{ coach.businessName }}</div>
        </div>
      </div>
    </div>
    <div class="step__section step__section--video">
      <div class="step__title">Видео-визитка</div>
      <iframe
        width="100%"
        height="315"
        :src="`https://www.youtube.com/embed/${videoUrl}`"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
    <div class="step__section step__section--content">
      <div class="step__title">О сборной</div>
      <div v-html="asideData.stepData.step3.content" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    asideData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      asideDataClone: {},
      videoUrl: ''
    };
  },
  watch: {
    asideDataClone: {
      deep: true,
      handler() {
        this.$emit('update:asideData', this.asideDataClone);
      }
    }
  },
  created() {
    this.asideDataClone = _.cloneDeep(this.asideData);
    this.asideDataClone.isValid = true;
    this.videoUrl = this.extractVideoID(this.asideDataClone.stepData.step3.youtubeVideoUrl);
  },
  methods: {
    extractVideoID(url) {
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      if (match && match[7].length === 11) {
        return match[7];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.step {
  &__title {
    &__required {
      color: #eb5757;
    }
  }

  &__card {
    &__coach-section {
      margin-bottom: 12px;
    }

    &__list li {
      margin-bottom: 8px;
      line-height: 20px;

      &:last-child {
        margin-bottom: 16px;
      }
    }

    &__coach-title {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 8px;
    }

    &__business {
      color: $ui-black;
      font-weight: 500;
      font-size: 16px;
      margin-bottom: 16px;
      span {
        color: #ababba;
      }
    }
  }

  &__section--content {
    margin-bottom: 32px;
    padding-bottom: 20px !important;

    &::v-deep ul,
    &::v-deep ol {
      p,
      h1,
      h3 {
        display: inline;
      }
    }

    &::v-deep ul {
      list-style-type: disc;
      list-style-position: inside;
    }
    &::v-deep ol {
      list-style-type: decimal;
      list-style-position: inside;
    }

    &::v-deep p,
    &::v-deep h1,
    &::v-deep h3 {
      @include uiFont;
      font-weight: 400;
    }

    &::v-deep p {
      font-size: 14px;
      margin-bottom: 8px;
    }

    &::v-deep li {
      font-size: 14px;
      margin-bottom: 8px;
    }

    &::v-deep h1 {
      font-size: 36px;
      margin-bottom: 18px;
    }

    &::v-deep h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .ui-kit-file {
        display: contents;
      }
    }
  }
}
</style>
